/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'alert';
const componentName = 'alert-config-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalHeaderNew = `${prefix}.modalHeaderNew`;
export const modalHeaderEdit = `${prefix}.modalHeaderEdit`;

export const enableAlertTriggerLabel = `${prefix}.enableAlertTriggerLabel`;
export const conditionsHeader = `${prefix}.conditionsHeader`;
export const throttleAlertInputLabel = `${prefix}.throttleAlertInputLabel`;
export const sourceInputLabel = `${prefix}.sourceInputLabel`;
export const objectInputLabel = `${prefix}.objectInputLabel`;
export const virtualServiceRadioOption = `${prefix}.virtualServiceRadioOption`;
export const autoScaleAlertInputLabel = `${prefix}.autoScaleAlertInputLabel`;
export const instanceInputLabel = `${prefix}.instanceInputLabel`;
export const dropdownAllInstances = `${prefix}.dropdownAllInstances`;
export const numberOfOccurrencesInputLabel = `${prefix}.numberOfOccurrencesInputLabel`;
export const categoryInputLabel = `${prefix}.categoryInputLabel`;
export const realtimeRadioOption = `${prefix}.realtimeRadioOption`;
export const rollingWindowRadioOption = `${prefix}.rollingWindowRadioOption`;
export const timeWindowInputLabel = `${prefix}.timeWindowInputLabel`;
export const metricOccursInputLabel = `${prefix}.metricOccursInputLabel`;
export const comparatorInputLabel = `${prefix}.comparatorInputLabel`;
export const durationInputLabel = `${prefix}.durationInputLabel`;
export const removeMetricButtonTitle = `${prefix}.removeMetricButtonTitle`;
export const andRadioOption = `${prefix}.andRadioOption`;
export const andNotRadioOption = `${prefix}.andNotRadioOption`;
export const orRadioOption = `${prefix}.orRadioOption`;
export const eventOccursInputLabel = `${prefix}.eventOccursInputLabel`;
export const selectEventPlaceholder = `${prefix}.selectEventPlaceholder`;
export const removeEventButtonTitle = `${prefix}.removeEventButtonTitle`;
export const actionsHeader = `${prefix}.actionsHeader`;
export const alertActionInputLabel = `${prefix}.alertActionInputLabel`;
export const alertExpiryTimeInputLabel = `${prefix}.alertExpiryTimeInputLabel`;
export const eventsLabelWithCountLabel = `${prefix}.eventsLabelWithCountLabel`;
export const valueUnitsLabel = `${prefix}.valueUnitsLabel`;
export const enterThresholdLabel = `${prefix}.enterThresholdLabel`;
export const durationLabel = `${prefix}.durationLabel`;
export const selectMetricRuleLabel = `${prefix}.selectMetricRuleLabel`;
export const multipleEventsOperatorLabel = `${prefix}.multipleEventsOperatorLabel`;
export const metricsLabelWithCount = `${prefix}.metricsLabelWithCount`;

export const ENGLISH = {
    [modalHeaderEdit]: 'Edit Alert Configuration',
    [modalHeaderNew]: 'New Alert Configuration',
    [enableAlertTriggerLabel]: 'Enable Alert Trigger',
    [conditionsHeader]: 'Conditions',
    [throttleAlertInputLabel]: 'Throttle Alert',
    [sourceInputLabel]: 'Source',
    [objectInputLabel]: 'Object',
    [virtualServiceRadioOption]: 'Virtual Service',
    [autoScaleAlertInputLabel]: 'AutoScale Alert',
    [instanceInputLabel]: 'Instance',
    [dropdownAllInstances]: 'All Instances',
    [numberOfOccurrencesInputLabel]: 'Number of Occurrences',
    [categoryInputLabel]: 'Category',
    [realtimeRadioOption]: 'Real-time',
    [rollingWindowRadioOption]: 'Rolling Window',
    [timeWindowInputLabel]: 'Time Window',
    [metricOccursInputLabel]: 'Metric Occurs',
    [comparatorInputLabel]: 'Comparator',
    [durationInputLabel]: 'Duration',
    [removeMetricButtonTitle]: 'Remove Metric',
    [andRadioOption]: 'AND',
    [andNotRadioOption]: 'AND NOT',
    [orRadioOption]: 'OR',
    [eventsLabelWithCountLabel]: 'Events ({0})',
    [eventOccursInputLabel]: 'Event Occurs',
    [selectEventPlaceholder]: 'Select an Event',
    [removeEventButtonTitle]: 'Remove Event',
    [actionsHeader]: 'Actions',
    [alertActionInputLabel]: 'Alert Action',
    [alertExpiryTimeInputLabel]: 'Alert Expiry Time',
    [valueUnitsLabel]: 'Value (Units)',
    [enterThresholdLabel]: 'Enter Threshold',
    [durationLabel]: 'Duration (Seconds)',
    [selectMetricRuleLabel]: 'Select Metric Rule',
    [multipleEventsOperatorLabel]: 'Multiple Events Operator',
    [metricsLabelWithCount]: 'Metrics ({0})',
};
